import React, { useState } from 'react';
import SplashScreen from '../components/SplashScreen';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import WorkflowVisualizer from '../components/WorkflowVisualizer';
import IntegrationMarquee from '../components/IntegrationMarquee';
import WorkflowShowcase from '../components/WorkflowShowcase';
import FeaturesBento from '../components/FeaturesBento';
import Testimonials from '../components/Testimonials';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';

const LandingPage = () => {
  const [showSplash, setShowSplash] = useState(true);

  return (
    <>
      {showSplash && (
        <SplashScreen onComplete={() => setShowSplash(false)} />
      )}
      
      <div data-testid="landing-page" className="min-h-screen bg-slate-950 overflow-hidden relative">
      {/* Background Logo Watermark - Global */}
      <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
          <img 
            src="/vritta-logo.png" 
            alt="" 
            className="w-[1000px] h-[1000px] object-contain opacity-[0.05]"
          />
        </div>
      </div>

      {/* Circuit/Chip Pattern Background - Global */}
      <div className="fixed inset-0 pointer-events-none z-0">
        <div
          className="absolute inset-0 opacity-[0.06]"
          style={{
            backgroundImage: `
              linear-gradient(rgba(16, 185, 129, 0.3) 1px, transparent 1px),
              linear-gradient(90deg, rgba(16, 185, 129, 0.3) 1px, transparent 1px)
            `,
            backgroundSize: '80px 80px',
          }}
        />
        <div
          className="absolute inset-0 opacity-[0.08]"
          style={{
            backgroundImage: `radial-gradient(circle at 1px 1px, rgba(16, 185, 129, 0.5) 1px, transparent 0)`,
            backgroundSize: '40px 40px',
          }}
        />
      </div>

      {/* Glow effects */}
      <div className="fixed inset-0 pointer-events-none z-0">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-emerald-500/5 rounded-full blur-[150px]" />
        <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-pink-500/5 rounded-full blur-[100px]" />
        <div className="absolute top-1/2 left-0 w-[300px] h-[300px] bg-cyan-500/5 rounded-full blur-[80px]" />
      </div>
      
      <Navbar />
      <main className="relative z-10">
        <Hero />
        <WorkflowVisualizer />
        <IntegrationMarquee />
        <WorkflowShowcase />
        <FeaturesBento />
        <Testimonials />
        <CTASection />
      </main>
      <Footer />
    </div>
    </>
  );
};

export default LandingPage;
